
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pass/coupon",
      function () {
        return require("private-next-pages/pass/coupon/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pass/coupon"])
      });
    }
  